import { useIntl } from 'react-intl';

import { Button, FocusRingVariants } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import FrayedDivider from '@/components/schools/FrayedDivider';
import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';

import messages from './messages';
import { Benefit, ContentWrapper, Grid, Heading, Photo, Wrapper } from './styles';

const Classroom = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<FrayedDivider />
			<Grid>
				<Photo>
					<Image
						src="/_n/images/schools/classroom-headphones.webp"
						fill
						alt="Boy listening to music lying on grass"
						style={{ objectFit: 'contain' }}
					/>
				</Photo>
				<ContentWrapper>
					<Heading>
						{formatMessage(messages.heading, {
							break: <br />,
							decoratedtext: chunks => <span>{chunks}</span>,
						})}
					</Heading>
					<Benefit>{formatMessage(messages.copy)}</Benefit>
					<Button
						focusRingVariant={FocusRingVariants.Dark}
						backgroundColor="schoolBlue"
						onPress={() => onCtaClick(messages.heading.defaultMessage)}
					>
						{formatMessage(messages.cta)}
					</Button>
				</ContentWrapper>
			</Grid>
			<FrayedDivider isFlipped />
		</Wrapper>
	);
};

export default Classroom;
